<template>
	<main-filter>
		<div class="filters__item filters__item--3">
			<div class="filters__item--double">
				<InputText :label="'Поиск по фамилии'" :placeholder="'Введите фамилию менеджера'" :input-gray="true" v-model="filter.lastName"/>
			</div>
		</div>
		<div class="filters__item">
			<ProductCategories v-if="!showAddPopup" v-model="filter.productGroups" ref="productGroups"/>
		</div>
		<div class="filters__item filters__item--2">
			<div class="filters__btns">
				<button type="button" class="btn btn--color" @click="updateManagers">Применить</button>
				<button type="button" class="btn btn--trans" @click="clearFilter">Сбросить фильтр</button>
			</div>
		</div>
	</main-filter>
	<div class="table-card">
		<div class="table-wrap">
			<table class="table table--default" v-if="managers?.items.length">
				<thead class="table__head">
					<tr class="table__row">
						<td class="table__col">№</td>
						<td class="table__col">ФИО менеджера</td>
						<td class="table__col">Телефон</td>
						<td class="table__col">E-mail</td>
						<td class="table__col">Товарные категории</td>
						<td class="table__col"></td>
					</tr>
					<tr class="table__margin">
						<td colspan="100%"></td>
					</tr>
				</thead>
				<tbody class="table__body">
					<template v-for="item in managers?.items" :key="item" >
						<tr  class="table__row">
							<td class="table__col">
								<span class="table__col-label">№ менеджера</span>
								<span class="table__col-cont">№{{ item.id }}</span>
							</td>
							<td class="table__col">
								<span class="table__col-label">ФИО менеджера</span>
								<span class="table__col-cont">{{item.name}} {{ item.lastName }}</span>
							</td>
							<td class="table__col">
								<span class="table__col-label">Телефон</span>
								<div class="table__col-phones">
									<div v-for="(phone, index) in item.phones" :key="index">
										<a  :href="`tel:${phone}`">+{{ phone }}</a>
									</div>
								</div>
							</td>
							<td class="table__col nowrap">
								<span class="table__col-label">E-mail</span>
								<span class="table__col-cont">
									<a :href="`mailto:${item.email}`">{{item.email}}</a>
								</span>
							</td>
							<td class="table__col">
								<span class="table__col-label">Товарные категории</span>
								<span class="table__col-cont">{{ getStringProductGroup(item.productGroups, 'name') || 'Не найдено' }}</span>
							</td>
							<td class="table__col table__col--btn">
								<button v-if="['administrator'].includes(getUserRole)" class="link" @click="selectedManager = item,showAddPopup = true">Подробнее</button>
							</td>
						</tr>
						<tr class="table__margin">
							<td colspan="100%"></td>
						</tr>
					</template>
				</tbody>
			</table>
			<div v-else class="table-card__empty">Менеджеры категорий не найдены</div>
		</div>
		<div class="pagination">
			<vue-awesome-paginate
				v-if="managers?.countTotal > filter.limit"
				:total-items="+managers?.countTotal"
				:items-per-page="filter.limit"
				:max-pages-shown="3"
				v-model="currentPage"
				:on-click="updateManagers" />
		</div>
	</div>
	<PageLoader v-if="isLoading"/>
	<teleport to="body">
		<transition name="modal">
			<AddCategoryManagerPopup :manager="selectedManager" :productGroups="productGroups" v-if="showAddPopup" @close="showAddPopup = false" />
		</transition>
	</teleport>
</template>

<script>
import MainFilter from "@/components/blocks/MainFilter.vue";
import ProductCategories from "@/components/blocks/ProductCategories.vue";
import PageLoader from "@/components/base/utils/PageLoader.vue";
import InputText from "@/components/base/utils/formElements/InputText.vue";
import {mapActions, mapGetters} from "vuex";
import AddCategoryManagerPopup from "@/components/sections/CategoryManagers/AddCategoryManagerPopup.vue";

export default {
	name: "CategoryManagersTable",
	components: {AddCategoryManagerPopup, ProductCategories,MainFilter,PageLoader, InputText},

	data() {
		return {
			showAddPopup: false,
			selectedManager: {},
			currentPage: 1,
			filter: {
				productGroups: '',
				offset: 0,
				limit: 10,
				lastName: ''
			}
		}
	},
	async created() {
		await this.requestManagers(this.filter)
	},

	methods: {
		getStringProductGroup(group,name) {
			return group.reduce((acc,item,index) => acc += `${item[name]}${group.length != index + 1 ? ', ' : "."}`,'')
		},
		async updateManagers(value) {
			this.filter.offset = (value - 1) * this.filter.limit || 0
			await this.requestManagers(this.filter)
		},

		clearFilter() {
			this.$refs.productGroups.clearAll()
			this.filter.lastName = ''
			this.updateManagers()
		},
		...mapActions({
			requestManagers: 'categoryManagers/requestManagers',
		}),
	},
	computed: {
		...mapGetters({
			managers: 'categoryManagers/getManagers',
			isLoading: 'isLoading',
			getUserRole: 'user/getUserRole',
		})
	}
}
</script>


